module.exports = __webpack_public_path__ + "img/28.dc84cdf8.jpg";